export default __webpack_public_path__ + "static/media/textleftw.540b8c12.png";